/* eslint-disable @typescript-eslint/no-explicit-any */
import { PlatformType } from '../context/socialProvider';
import AdComments from '../pages/AdComments/AdComments';
import UnifiedCommentDto from '../types/comment.types';
import { SupportedLanguage } from '../types/language.typtes';
import { API } from './index';
import Cookies from 'js-cookie';

//ACTUALLY RETURNS THE COMMENTS
export const getComments = async (
  userId: number,
  postId: string,
  page: number,
  order: string,
  status?: number
) => {
  try {
    const response = await API.get('/api/v1/comment/list', {
      params: {
        userId,
        postId,
        status,
        page,
        order: order,
        orderBy: 'timestamp',
        generateCommentResponses: true,
      },
    });

    return response;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const getUnifiedComments = async (
  socialId: number,
  postId?: string,
  status?: 0 | 1 | 2 | 3,
  page: number = 1,
  pageSize: number = 10,
  order: 'ASC' | 'DESC' = 'DESC',
  orderBy?: string,
  searchTerm?: string,
  removal?: boolean,
  generateResponses?: boolean,
  autoMod?: boolean,
  isMetaAd?: boolean
): Promise<{
  result: UnifiedCommentDto[];
  total: number;
}> => {
  try {
    const response = await API.get('/api/v1/unified-comments/list', {
      params: {
        socialId,
        postId,
        status,
        page,
        pageSize,
        order,
        orderBy,
        searchTerm,
        autoMod,
        isMetaAd,
        removal,
        generateResponses,
      },
    });

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

export const getCommentById = async (
  commentId: string,
  socialId: number,
  regenerate: boolean
) => {
  try {
    const response = await API.get(`/api/v1/comment/single/${commentId}`, {
      params: {
        socialId,
        regenerateCommentReponse: regenerate,
      },
    });

    return response;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const commentReplyById = async (
  commentId: string,
  reply: string,
  socialId: number
) => {
  try {
    const response = await API.post('/api/v1/unified-comments/reply', {
      commentId,
      message: reply,
      socialId,
    });
    return response;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

export const changeHideCommentStatus = async (
  commentId: string | number,
  hide: boolean,
  socialId: number
) => {
  const payload = {
    commentId,
    hide,
    socialId,
  };

  try {
    const response = await API.post(`/api/v1/unified-comments/hide`, payload);
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const deleteComment = async (
  platformCommentId: string | number,
  socialId: number
) => {
  try {
    const response = await API.delete('/api/v1/unified-comments/delete', {
      params: {
        commentId: platformCommentId,
        socialId,
      },
    });
    console.log(response);
  } catch (error: any) {
    throw error.response.data;
  }
};

export const updateStatusComment = async (
  commentId: string | number,
  status: number,
  socialId: number
) => {
  const payload = {
    commentId,
    status,
    socialId,
  };

  console.log('UPDATE PAYLOAD', payload);

  try {
    const response = await API.put(
      `/api/v1/unified-comments/update-status`,
      payload
    );
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};

export const testModComment = async (commentText: string, socialId: number) => {
  try {
    const response = await API.post('/api/v1/automod/evaluate', {
      commentText,
      socialId,
    });

    console.log(response);
    return response;
  } catch (error: any) {
    throw error.response.data;
  }
};

/**
 * Get comment thread (replies) for a specific comment
 * This calls the unified-comments-thread endpoint
 */
export const getCommentThread = async (
  socialId: number,
  platformCommentId: string,
  page: number = 1,
  pageSize: number = 20
) => {
  try {
    const response = await API.get('/api/v1/unified-comments/thread', {
      params: {
        socialId,
        platformCommentId,
        page,
        pageSize,
      },
    });

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};

export interface TranslatedCommentDto {
  commentId: string;
  originalText: string;
  translatedText: string;
  sourceLanguage: string;
  targetLanguage: SupportedLanguage;
  success: boolean;
  error?: string;
}

/**
 * Translates the comment
 */
export const translateComment = async (
  commentId: string,
  socialId: number,
  language: SupportedLanguage
): Promise<TranslatedCommentDto> => {
  try {
    const response = await API.get(`/api/v1/comment/translate/${commentId}`, {
      params: {
        socialId,
        language,
      },
    });

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error;
  }
};
